export function StatusBadge({ status }: { status: string }) {
  return (
    <span
      className={`settings-badge settings-badge-status-${status.toLowerCase().replace(/[^a-z]/g, "-")}`}
    >
      {status}
    </span>
  );
}

export function DiscrepancyBadge({
  providerActive,
  dbStatus,
}: {
  providerActive: boolean;
  dbStatus: string | null;
}) {
  const providerTerminal = !providerActive;
  const dbTerminal = dbStatus === "completed" || dbStatus === "failed";

  if (providerTerminal && !dbTerminal && dbStatus) {
    return (
      <span
        className="settings-badge settings-badge-status-failed"
        style={{ opacity: 0.8 }}
        title="Provider shows call ended but database still shows active"
      >
        Provider ended / DB active
      </span>
    );
  }

  if (!providerTerminal && dbTerminal) {
    return (
      <span
        className="settings-badge settings-badge-status-queued"
        style={{ opacity: 0.8 }}
        title="Provider shows call active but database shows terminal"
      >
        Provider active / DB terminal
      </span>
    );
  }

  if (!providerActive && !dbStatus) {
    return (
      <span
        className="settings-badge settings-badge-status-default"
        style={{ opacity: 0.8 }}
        title="Call from provider only, no database record"
      >
        Provider only
      </span>
    );
  }

  if (providerActive && dbStatus && !dbTerminal) {
    return (
      <span className="settings-badge settings-badge-status-completed" style={{ opacity: 0.8 }}>
        In sync
      </span>
    );
  }

  return null;
}
